export const SENDBIRD_CONFIG = {
    APP_ID: _SENDBIRD_APP_ID_,
    AI_AGENT_ID: _SENDBIRD_AGENT_ID_,
    DEFAULT_LANGUAGE: 'en-GB',
    DEFAULT_COUNTRY_CODE: 'GB',
    IS_VISIBLE: true
}
